import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

export const campPaNew: FaireAdCampaignEntity = {
  token: "camp_pa_new",
  type: "adCampaign",
  advertiserProfileToken: "adv_panache_apparel",
  segment: "NEW_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 13000,
  startedRunningAt: "2024-09-13",
  segmentMetrics: {
    numCustomersAcquired: 840,
    salesDollars: 922693,
    totalAdsSpendDollars: 58940,
    cpaDollars: 79.79,
    bestEstimateSalesDollars: 1084535,
    bestEstimateRoas: 18.4,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-24T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
